<div class="info-content-container">
  <div class="title-header">
    <span>{{ headline }}</span>
    @if (historyStack?.length && !sortActive) {
      <button class="icon-button faq-back" (click)="goBackInList()">
        <span class="icon-chevron-left"></span>
      </button>
    }
  </div>
  <div class="scroll-container">
    @if (currentItem?.items?.length || !historyStack?.length) {
      <div class="master-faq-list-container">
        <div class="master-faq-content">
          <div class="faq-layer">
            <div class="slider">
              <div class="faq-topic-layer">
                <ul>
                  @for (item of currentItem?.items; track item) {
                    <li (click)="selectItem(item)">
                      <a>{{ item.title.en }}</a>
                      @if (!item.content) {
                        <div class="faq-info-cell">
                          <label>{{ "admin.faq.item.childrenNodes" | translate }}</label>
                          <span>{{ item.items?.length || 0 }}</span>
                        </div>
                        <div class="faq-info-cell">
                          <label>{{ "admin.faq.item.totalAnswers" | translate }}</label>
                          <span>{{ item.totalItems }}</span>
                        </div>
                      }
                      <div class="faq-info-cell">
                        <label>{{ "admin.faq.item.languages" | translate }}</label>
                        <span>{{ languageCount(item) }}</span>
                      </div>
                      <div class="faq-info-cell">
                        <label>{{ "admin.faq.item.visibility" | translate }}</label>
                        <span>{{ "admin.faq.item.visibility" + item.visibility | translate }}</span>
                      </div>
                      <div class="button-container-cell">
                        @if (!sortActive) {
                          <button
                            matTooltip="{{ 'admin.faq.item.editItem' | translate }}"
                            (click)="$event.stopPropagation(); editFaqItem(item)"
                            class="icon-button">
                            <span class="icon-edit"></span>
                          </button>
                          <button [disabled]="!faqItem?.active && faqItem?.id" class="icon-button" (click)="$event.stopPropagation(); changeState(item)">
                            @if (item.active) {
                              <span class="icon-view" matTooltip="{{ 'admin.faq.item.deactivateItem' | translate }}"></span>
                            } @else {
                              <span class="icon-view-off" matTooltip="{{ 'admin.faq.item.activateItem' | translate }}"></span>
                            }
                          </button>
                          <button
                            matTooltip="{{ 'admin.faq.item.deleteItem' | translate }}"
                            (click)="$event.stopPropagation(); deleteFaq(item)"
                            class="icon-button">
                            <span class="icon-delete"></span>
                          </button>
                        } @else {
                          <button
                            [disabled]="$index === currentItem.items.length - 1"
                            (click)="$event.stopPropagation(); moveItem(item)"
                            class="icon-button chevrons">
                            <span class="icon-chevron-down"></span>
                          </button>
                          <button [disabled]="$index === 0" (click)="$event.stopPropagation(); moveItem(item, false)" class="icon-button chevrons">
                            <span class="icon-chevron-up"></span>
                          </button>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="no-data-container">
        <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
        <span>{{ "default.buttons.noData" | translate }}</span>
      </div>
    }
  </div>
</div>
